import { useQuery } from '@tanstack/react-query';
import type { PaginatedOffcutsDto, ListOffcutsQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface OffcutsApiResponse {
  success: boolean;
  data: PaginatedOffcutsDto;
}

export function useOffcuts(query?: Partial<ListOffcutsQuery>) {
  return useQuery({
    queryKey: queryKeys.offcuts.list(query),
    queryFn: async () => {
      const response = await apiClient.get<OffcutsApiResponse>('/offcuts', { params: query });
      return response.data.data;
    },
  });
}
